import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=ccd5d4fc&"
import script from "./FormPage.vue?vue&type=script&lang=js&"
export * from "./FormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccd5d4fc')) {
      api.createRecord('ccd5d4fc', component.options)
    } else {
      api.reload('ccd5d4fc', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=ccd5d4fc&", function () {
      api.rerender('ccd5d4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page/form/FormPage.vue"
export default component.exports